@if (cardInfo(); as cardInfo) {
  <crm-activity-card [activity]="activity()" [icon]="ActivityIcons[ActivityTypes.OpportunityChange]">
    <span activity-title>
      @if (headerText(); as headerText) {
        <strong>{{ headerText }}</strong>
        @if (salespersonId() && effectResult()?.opportunityUpdatedBy; as user) {
          {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.BY' | translate }}
          {{ user }}
        }
        @if (showPrimaryAssociation()) {
          @if (primaryAssociation(); as primaryAssociation) {
            {{ 'OBJECT_TYPES.FOR_LABEL' | translate }}
            <a [routerLink]="routePrefix() + '/' + primaryAssociation.linkUrl">{{ primaryAssociation.name }}</a>
          }
        }
      }
    </span>

    <div activity-subtitle>
      @if (cardInfo.activityInfo; as activityInfo) {
        @if (activityInfo.opportunityName) {
          @if (showPrimaryAssociation()) {
            {{ activityInfo.opportunityName }}
          } @else {
            <a (click)="handleOpenOpportunity()">{{ activityInfo.opportunityName }}</a>
          }
        }
      }
    </div>

    <div activity-preview>
      @if (cardInfo.activityInfo; as activityInfo) {
        @if (activityInfo.status) {
          <div class="activity-info">
            {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.STATUS' | translate }}
            {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.STATUS_CHANGE_MESSAGE' | translate }}
            <span
              [ngClass]="{
                'closed-lost': activityInfo.status === 'Closed-lost',
                'closed-won': activityInfo.status === 'Closed-won',
              }"
            >
              {{ activityInfo.status }}
            </span>
          </div>

          @if (!isClosedWon()) {
            <div class="activity-info">
              {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.REASON_MESSAGE' | translate }}
              <span>{{ activityInfo.lostReason }}</span>
            </div>
          }

          @if (activityInfo.notes) {
            <div>
              {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.NOTES_MESSAGE' | translate }}
              <span [innerHtml]="activityInfo.notes | sanitizeHtml"></span>
            </div>
          }
        }
      }
    </div>
  </crm-activity-card>
}
